<template>
  <div id="carousel-themes" v-if="contents && contents.length > 0">
    <div class="spotlights">
      <div class="text-left">In the spotlights</div>
      <div class="text-right"></div>
    </div>
    <div class="slide-spotlights">
      <carousel
        :items="2"
        :stagePadding="36"
        :margin="13"
        :nav="false"
        :dots="false"
        class="content-carousel"
      >
        <div
          v-for="content in contents"
          :key="content.id"
          class="slide-list"
          :style="{
            backgroundImage: content.thumbnailUrl
              ? `url(${content.thumbnailUrl})`
              : '',
          }"
          @click="() => onClickItem(content)"
        >
          <div class="title-name">{{ content.title }}</div>
        </div>
        <template slot="prev">
          <span class="owl-custom-prev">
            <i class="fas fa-arrow-left"></i>
          </span>
        </template>
        <template slot="next">
          <span class="owl-custom-next">
            <i class="fas fa-arrow-right"></i>
          </span>
        </template>
      </carousel>
    </div>
  </div>
</template>

<script>
import carousel from "vue-owl-carousel";
import axios from "axios";
import ExperienceService from "@/services/experience";
import StoryService from "@/services/story";
import EventService from "@/services/event";

export default {
  name: "carousel-themes",
  components: {
    carousel,
  },
  props: {
    travelerTypes: {
      type: Array,
      default: () => [],
    },
    locations: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      contents: [],
      final: false,
    };
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      const url = process.env.VUE_APP_API_URI;
      const postData = {
        query: `query contents($travelerTypes: [ID], $locations: [ID]) { contents(travelerTypes: $travelerTypes, locations: $locations) { hasNext results { id title name thumbnailUrl type }} }`,
        variables: {
          travelerTypes: this.travelerTypes,
          locations: this.locations,
        },
      };
      axios
        .post(url, postData, {
          headers: {
            "X-API-Key": process.env.VUE_APP_API_KEY,
          },
        })
        .then((res) => {
          const contents = res.data.data.contents;
          this.contents = contents.results;
          this.final = !contents.hasNext;
        })
        .catch(console.error);
    },
    onClickItem(content) {
      if (content.type === "story") {
        StoryService.openPopup(content.id);
      } else if (content.type === "event") {
        EventService.openPopup(content.id);
      } else {
        ExperienceService.openPopup(content.id);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#carousel-themes {
  .spotlights {
    display: flex;
    padding: 0 22px 30px;

    div {
      width: 50%;
    }
  }

  .slide-spotlights {
    padding-bottom: 50px;

    .slide-list {
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      margin-bottom: 10px;
      position: relative;
      height: 177.46px;
      background-color: #cecece;
      border-radius: 10px;
      -webkit-box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.3);
      -moz-box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.3);
      box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.3);
      .title-name {
        position: absolute;
        bottom: 0;
        height: 37.94px;
        width: 100%;
        font-size: 10px;
        font-weight: bold;
        padding: 5px;
        background-color: #ffffff;
        border-bottom-left-radius: 10px;
        border-bottom-right-radius: 10px;
      }
    }

    .content-carousel {
      position: relative;
      .owl-custom-prev {
        position: absolute;
        right: 45px;
        top: -55px;
      }
      .owl-custom-next {
        position: absolute;
        right: 15px;
        top: -55px;
      }
    }
  }
}
</style>
